<template>
	<div id="suppliersidebar">
		<ul>
			<li v-if="issessionset"><router-link to="/user">My Purchases</router-link></li>
			<li v-if="issessionset"><router-link to="/useraccount">Account Information</router-link></li>
			<li><router-link to="/cart">Cart</router-link></li>
		</ul>
	</div>
</template>

<script>
	export default{
		props: ['issessionset'],
		data(){
			return{}
		}
	}
</script>


// WEBPACK FOOTER //
// UserSidebar.vue?0b021433